import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/businesses/index.vue'

export default class extends Controller {
  connect() {
    this.vue = createApp(App)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
